import React, { useState, useEffect } from "react";
import "./DashboardContent.css";
import AOS from "aos";
import "aos/dist/aos.css";

function DashboardContent() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);
  return (
    <>
      <div className="main-banner">
        <img
          src={
            process.env.PUBLIC_URL +
            "/images/Dashboard/dashboard-banner-new.jpg"
          }
          // src="images/Dashboard/dashboard-banner-new.jpg"
          alt="banner"
          className="banner-img"
        />
      </div>
      <div className="dashboard-container">
        <div className="dashboard-wrap" data-aos="zoom-in-up">
          {/* <h2>Coming Soon...</h2> */}
          <p>
            You can now track your learning progress with a simple click! <br />{" "}
            Check the learning summary, weekly progress data, and trends for
            each track in the below dashboard.
          </p>
          {/* <iframe title="ATRIAS Academy Learning Board" width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=ba9fe005-9a24-4af5-9110-477dd5470dae&autoAuth=true&ctid=e0793d39-0939-496d-b129-198edd916feb" frameborder="0" allowFullScreen="true"></iframe> */}
          <iframe
            // title="ATRIAS Academy Learning Board"
            title="Vodafone Academy Learning Board"
            width="1140"
            height="541.25"
            // src="https://app.powerbi.com/reportEmbed?reportId=ba9fe005-9a24-4af5-9110-477dd5470dae&autoAuth=true&ctid=e0793d39-0939-496d-b129-198edd916feb"
            //src="https://app.powerbi.com/groups/dd9f7cb9-5044-4f4d-91ef-1953d406db9a/reports/d2ba8a6c-168c-4777-8e63-4d6691f10122/ReportSection9ed532d30012bba90034?experience=power-bi"
            src="https://app.powerbi.com/reportEmbed?reportId=d2ba8a6c-168c-4777-8e63-4d6691f10122&autoAuth=true&ctid=e0793d39-0939-496d-b129-198edd916feb"
            frameborder="0"
            allowFullScreen="true"
          ></iframe>
        </div>
      </div>
    </>
  );
}

export default DashboardContent;
